<div class="verify-user-container">
  <div class="top-panel">
    <a class="triggerbee-logo-container">
      <img class="triggerbee-logo triggerbee-logo--large" src="/assets/img/triggerbee-logo-black.svg" />
    </a>
  </div>
  <div class="container">
    <div class="content-panel">
      <p class="verify-user-title">{{ "registration.confirmVerifiedUserTitle" | translate }}</p>
      <p class="verify-user-text">{{ "registration.confirmVerifiedUserText" | translate }}</p>
      <div class="verify-user-text-btn">
        <button mat-stroked-button class="secondary-button" (click)="closePage()">{{ "generic.close" | translate | uppercase }}</button>
        <button mat-stroked-button class="primary-button" (click)="continue()">
          {{ "registration.toTriggerbee" | translate | uppercase }}
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
